import { useEffect, useRef } from 'react';
import { Modal } from 'react-bootstrap';

// Botão VOLTAR do celular (e do navegador) fecha o modal em vez de sair da tela
// (pedido de Jason 2026-09-25). Ao abrir, empurra uma entrada no histórico; o "voltar" consome
// essa entrada e o modal fecha. Fechar por outro caminho (X, Esc, clique fora, botão Fechar)
// devolve a entrada com `history.back()`, para o histórico não acumular lixo.
//
// Cuidados:
//  - se o modal fechou porque o usuário NAVEGOU (ex.: "Alterar" leva à edição), a entrada do
//    topo já é outra: aí não chama `back()` (senão voltaria da página nova). Quem navega a
//    partir do modal deve usar `replace` (o link substitui a entrada do modal);
//  - modais empilhados (um abrindo outro) funcionam: cada um tem a própria entrada e o
//    `voltar` fecha o de cima primeiro.
const MARCA = 'modalVoltar';

export function useVoltarFecha(aberto, aoFechar) {
  const aoFecharRef = useRef(aoFechar);
  aoFecharRef.current = aoFechar;

  useEffect(() => {
    if (!aberto) return undefined;

    const identificador = `${Date.now()}-${Math.random()}`;
    window.history.pushState({ ...window.history.state, [MARCA]: identificador }, '');
    let consumido = false;

    const aoVoltar = () => {
      // só reage se a entrada deste modal saiu do topo (voltar consumiu)
      if (window.history.state?.[MARCA] === identificador) return;
      consumido = true;
      aoFecharRef.current();
    };
    window.addEventListener('popstate', aoVoltar);

    return () => {
      window.removeEventListener('popstate', aoVoltar);
      if (!consumido && window.history.state?.[MARCA] === identificador) {
        window.history.back();
      }
    };
  }, [aberto]);
}

export default function ModalVoltar({ show, onHide, ...resto }) {
  useVoltarFecha(show, onHide);
  return <Modal show={show} onHide={onHide} {...resto} />;
}

// react-bootstrap expõe as partes como propriedades de `Modal`; repassa pra manter a sintaxe.
ModalVoltar.Header = Modal.Header;
ModalVoltar.Title = Modal.Title;
ModalVoltar.Body = Modal.Body;
ModalVoltar.Footer = Modal.Footer;
